(function(app, $) {
    var $cache = {};

    function initializeCache() {
        $cache.window = $(window);
        $cache.body = $('body.page_homepage');
        $cache.shopCtnr = $cache.body.find('div.shop-container div.shop-infos-container');
    }

    function initializeEvents() {
        $cache.window.on('load', function() {

            resizeShops();
        });

        var timeoutResize;
        $cache.window.resize(function() {
            if(typeof timeoutResize !== 'undefined') {
                clearTimeout(timeoutResize);
            }
            timeoutResize = setTimeout(function() {
                resizeShops();
            }, 50);
        });
    }

    function resizeShops() {
        $cache.shopCtnr.each(function() {
            var $self = $(this);

            if(!app.device.isMobile) {
                var imageHeight = parseInt($self.siblings('div.shop-image-container').outerHeight()),
                    textHeight = parseInt($self.outerHeight()),
                    height = ((imageHeight > textHeight) ? imageHeight : textHeight);

                $self.css('height', imageHeight + 'px');
            }
            else {
                $self.removeAttr('style');
            }
        });
    }

    app.components = app.components || {};
    app.components.homepage = {
        init : function() {
            initializeCache();
            initializeEvents();
        }
    };
}(window.app = window.app || {}, jQuery));
